import { FieldErrors, UseFormRegister } from "react-hook-form";
import { CreateEmpresa } from "../../../types/empresa";
import { InputCreateEmpresaForm } from "./InputCreateEmpresaForm";
import { SelectCreateEmpresaForm } from "./SelectCreateEmpresaForm";
import { EmpresaFiltersData } from "../../../types/filter";

interface Props {
    register: UseFormRegister<CreateEmpresa>;
    selectValues: EmpresaFiltersData;
}

export function UltimaVisitaSection({ register, selectValues }: Props) {
    return (
        <div className="flex gap-x-2">
            <div className="w-[200px]">
                <p className="text-xl font-semibold">Ultima Visita</p>
            </div>

            <InputCreateEmpresaForm
                height="h-[35px]"
                width="w-[300px]"
                label="Fecha de visita"
                type="datetime-local"
                register={register("ultimaVisita.fecha")}/>

            <SelectCreateEmpresaForm
                height="h-[35px]"
                width="w-[300px]"
                label="Tipo de Visita"
                register={register("ultimaVisita.tipoVisitaId")}
                datos={selectValues.tiposVisita.map((tipo, index) => (
                    <option key={index} value={tipo.id}>{tipo.nombre}</option>
                ))}/>

            <SelectCreateEmpresaForm 
                height="h-[35px]"
                width="w-[300px]"
                label="Turno"
                register={register("ultimaVisita.turnoId")}
                datos={selectValues.turnos.map((turno, index) => (
                    <option key={index} value={turno.id}>{turno.nombre}</option>
                ))}/>
        </div>
    );
}